<template>
  <div class="modal" @mousedown="closeModal">
    <div class="card" style="max-width: 550px">
      <div class="card-header">
        <h1>Edit Skip Criteria</h1>
      </div>
      <form class="card-body">
        <div class="row" ref="rows" v-for="(crit, idx) of criteria" :key="idx">
          <input type="text" class="form-control" placeholder="Field Key" v-model="crit.key" @blur="removeEmptyRows">
          <input type="text" class="form-control" placeholder="Field Value" v-model="crit.value"
            @blur="removeEmptyRows">
        </div>
        <div class="row">
          <input type="text" class="form-control" placeholder="Field Key" @keydown="addNewCrit">
          <input type="text" class="form-control" placeholder="Field Value" disabled>
        </div>
      </form>
      <div class="card-footer">
        <button class="button primary" @click="attemptUpdateSkipCriteria">
          Save Changes
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { updateFormSkipCriteria } from "@/api";

export default {
  name: "FormSettingsModal",
  props: {
    form: Object,
  },
  data() {
    return {
      criteria: []
    }
  },
  created() {
    const criteria = this.form.skipCriteria;
    if (criteria) {
      for (let key of Object.keys(criteria)) {
        const values = Array.isArray(criteria[key]) ? criteria[key] : [criteria[key]];
        for (let value of values) {
          this.criteria.push({ key: key, value: value });
        }
      }
    }
  },
  methods: {
    closeModal(event) {
      const nameElement = this.$refs.name;
      if (nameElement && nameElement == document.activeElement) {
        return;
      }

      if (event.target.className != "modal") {
        return;
      }
      this.$emit("closeModal");
    },
    async attemptUpdateSkipCriteria() {
      try {
        const criteria = {};

        for (let crit of this.criteria) {
          if (crit.key && crit.value) {
            // Check if the key already exists in the criteria object
            if (criteria[crit.key]) {
              // If it's already an array, push the new value
              if (Array.isArray(criteria[crit.key])) {
                criteria[crit.key].push(crit.value);
              } else {
                // If it's not an array, convert it into one and then push
                criteria[crit.key] = [criteria[crit.key], crit.value];
              }
            } else {
              // If the key doesn't exist, assign the value as an array
              criteria[crit.key] = [crit.value];
            }
          }
        }

        // Send the updated criteria to the server
        await updateFormSkipCriteria(this.form.id, criteria);
        this.$emit('closeModal');
      } catch (err) {
        console.error(err);
        alert('Error: ' + err);
      }
    },
    addNewCrit(event) {

      if (event.key.length > 1) {
        return;
      }

      this.criteria.push({
        key: '',
        value: ''
      })

      this.$nextTick(() => {
        const rows = this.$refs.rows;
        if (!rows) return;
        const lastRow = rows[rows.length - 1];
        lastRow.querySelector('input').focus();
      })
    },
    removeEmptyRows() {
      this.$nextTick(() => {
        this.criteria = this.criteria.filter(crit => {
          return crit.key || crit.value;
        })
      })
    }
  },
  emits: ["closeModal", "openModal", "updateFormName"],
};
</script>

<style scoped>
.card {
  position: relative;
}

.form-preview {
  display: block;
  width: 100%;
  background-size: 100%;
  background-position: top center;
  background-repeat: no-repeat;
  aspect-ratio: 1.5;
  border: 10px solid #e1e6ea;
  border-bottom: 1px solid #00000022;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
}

a {
  word-wrap: break-word;
}

.form-settings {
  position: absolute;
  top: 20px;
  right: 20px;
  width: 20px;
  display: block;
}

.row {
  display: flex;
  gap: 2px;
}

.row .form-control {
  font-size: 16px;
  padding: 10px;
}
</style>